import React, { useEffect, useState } from 'react';
import { MachineData } from '../../types/types';
import { formatNumber } from '../../utils/formatters';
interface ProcessFlowChartProps {
  machineData: MachineData[];
  timeRange: 'day' | 'week' | 'month' | 'custom';
  dateRange: {
    startDate: Date;
    endDate: Date;
  };
}
export const ProcessFlowChart: React.FC<ProcessFlowChartProps> = ({
  machineData,
  timeRange,
  dateRange
}) => {
  const [adjustedData, setAdjustedData] = useState(machineData);
  useEffect(() => {
    // Simuliere unterschiedliche Daten basierend auf dem Zeitraum
    const timeRangeFactor = timeRange === 'day' ? 0.8 : timeRange === 'week' ? 1.0 : timeRange === 'month' ? 1.2 : 1.1; // custom
    const newData = machineData.map(machine => {
      const adjustedEfficiency = Math.min(Math.round(machine.metrics.efficiency * timeRangeFactor), 100);
      const adjustedLoad = Math.min(Math.round(machine.metrics.currentLoad * (timeRange === 'day' ? 0.9 : timeRange === 'week' ? 1.0 : timeRange === 'month' ? 1.1 : 1.05)), 100);
      return {
        ...machine,
        metrics: {
          ...machine.metrics,
          efficiency: adjustedEfficiency,
          currentLoad: adjustedLoad
        }
      };
    });
    setAdjustedData(newData);
  }, [machineData, timeRange, dateRange]);
  return <div className="h-full flex items-center justify-center" data-id="element-50">
      <div className="text-center" data-id="element-51">
        <p className="text-gray-300 mb-4" data-id="element-52">
          Prozessfluss-Visualisierung für Zeitraum:{' '}
          {timeRange === 'day' ? 'Tag' : timeRange === 'week' ? 'Woche' : timeRange === 'month' ? 'Monat' : 'Benutzerdefiniert'}
        </p>
        <div className="flex flex-col items-center" data-id="element-53">
          <div className="grid grid-cols-3 gap-4 w-full max-w-4xl" data-id="element-54">
            {adjustedData.map((machine, index) => <div key={machine.id} className={`p-3 rounded-lg border ${machine.status === 'operational' ? 'border-green-500 bg-green-500/10' : machine.status === 'maintenance' ? 'border-yellow-500 bg-yellow-500/10' : 'border-red-500 bg-red-500/10'}`} data-id="element-55">
                <div className="text-sm font-medium text-gray-200" data-id="element-56">
                  {machine.name}
                </div>
                <div className="mt-1 flex justify-between text-xs" data-id="element-57">
                  <span className="text-gray-400" data-id="element-58">Effizienz:</span>
                  <span className="text-white" data-id="element-59">
                    {machine.metrics.efficiency}%
                  </span>
                </div>
                <div className="mt-1 flex justify-between text-xs" data-id="element-60">
                  <span className="text-gray-400" data-id="element-61">Durchsatz:</span>
                  <span className="text-white" data-id="element-62">
                    {formatNumber(Math.round(machine.metrics.efficiency / 10 * (machine.metrics.currentLoad / 100) * 60))}{' '}
                    Fässer/h
                  </span>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </div>;
};